var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"inspire"}},[_c('AppMenu'),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('RightDrawer'),_vm._v(" "),_c('v-main',{attrs:{"app":""}},[_c('router-view')],1),_vm._v(" "),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }